module.exports = __WEBPACK_EXTERNAL_MODULE__MALPRACTICE__b6a5fc38__;